<template>
    <v-system-bar v-show="getNotIssuedCount > 0" window dark>
        <div v-show="getNotIssuedCount > 0">
            <div class="not-issued-link" @click="routeNext('/order/not-issued')">
                <svg-icon type="mdi" :path="$data.icons.menu" />
                <span>{{ getNotIssuedCount }}</span>
            </div>

        </div>

    </v-system-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import SvgIcon from "@jamescoyle/vue-icon";
import {mdiAccountCash} from "@mdi/js";

export default {
    name: "SystemBarPart",
    components: {SvgIcon},
    data: () => ({
        order: 0,
        showMessages: false,
        icons: {
            account: mdiAccountCash,
        },
    }),

    computed: {
        ...mapGetters(['GET_NOT_ISSUED_COUNT']),
        getNotIssuedCount() {
            return this.GET_NOT_ISSUED_COUNT;
        }
    },

    methods: {
        routeNext(route) {
            return this.$router.push(route);
        }
    }
}
</script>

<style scoped>
.icon-bar{margin-right: 0!important; }
.system-link{text-decoration: none;}
.not-issued-link:hover{cursor: pointer;}
</style>
